import { render, staticRenderFns } from "./ViPaymentCompletd.vue?vue&type=template&id=3ed02b7d&scoped=true"
import script from "./ViPaymentCompletd.vue?vue&type=script&lang=js"
export * from "./ViPaymentCompletd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed02b7d",
  null
  
)

export default component.exports